// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:font/woff2;base64,d09GMgABAAAAAAQ0AA0AAAAAB7QAAAPhAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHGQGYD9TVEFUbABsEQgKhByDVwsSAAE2AiQDEgQgBYRSByAbeAbIBB7+v7O6rypwD1FDtZUGlTNBj+Ws9BesZ/y90NfW/1yT742oLjYb2BQv+i8inkeVcWrorBJ0E5vogGwG4a2boB9cXYIATIwmFCk9M68Mm7N5rhsbGgT+r5Ax2+noxBAyekCDXgFDDMAyIE0iW4sWHXraK5AxHdkrJqPF0NGahCwkesTRHg0OshcW2vGivP9Oo6gnQTOW2gUokb2yN6AwiQAYFgF93MxwpMzsvLwmN9pLUtKFQHi65ywWEtKCzq65QkZmMgp9FivKSAidmDxmtoQkzAyIKd4hTHOgB+FpiqM4kMmAXEqTk6rg60UPbhcJhVbaceJhzuu899+p6gI75beqb9ST6gn1kHpA3Tvs3qDw7XQy8gVCVQk5Zhr0ziAW5LTpt4YKjUl7LbQpSvBqZBkfaRlv0dls0836EF1LbY1DW1VlrRG1lsrEyoqk8sqEsvL4iubNgUBArAoGg+Ytfr+/3HQ8EAiYNvt8Plb6zVuCweBws8/n85m1PbERgo1fa9aaNSE0bw4IsarLGljpq9gSFGKVKMEw5UZz71yxKhAIjL0/BdPSZGr0wyv9fn+E389K35fe6d6XS2613mrf8dXXt1q/2NV2q7XmRnMTqv/Qy5cvXzrvzr+2suMTF1dlr6upzV67uPL4xLK4Vb1nh5ZVWtNrvrXH1I5ssoxLXjqqJSO+M31HYP36kR2WZiU7LqFGm15evTB0Q29cVwbnfvSTM8f5x1fZeB41ub/M5ZXt4p9n7/e8/yFevPDn+bs97/6R8/lrnyzb0XPHk+Vr1z9etrPnzidLeWe7+1/5HF2NLuli3OWzVyPCxnSGrleW9WoNLurtnJCbm1R0u+GHPy64K3S1upS9kZfP7JgSPSh//Mxhs/tkfDn886rOul9qAHiJAKS//l/644/3GkPi/zZIshfgg+P6S4APjsffg3pO9speONDdOuYmsi+BbcnVtBnpQvbyJQFUJ+PCQwbRZJIG0crI29yR9tu4DpvGSIeaRHqMChKFDpWw8R8qU8TFUU09qmUQ2zU6YimTxQ/ClEeRCJlIBSoxgImojIVhQR2m10UBNWHBAOZX8Hoo4XQzlwI8zMZFM07ycNBJF3OppB1Q2CbgoLXep1BKrVpMO3Zm00wbt0smDpw4yaeZubQzG0e78lIW4aIFj5o+h0LmMZdb7sBNO21MIQUVPaQ5/Lce3CiEMpUYIoii9eOwU0gh9iERQUpI+ObhpCfPHmOSwk9WeEMlOw0P3SzqyeboRe8ynVAiUbDjwUMnTtp7bMojjakoKKQcVEShRIU5qUA7c5YB84nA1N9ji9H5sQE=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* All fonts are self-hosted via public/fonts/gfonts.css (linked from
   index.html). CDN imports duplicated them and pinned Inter to weight 400,
   which forced synthetic bold everywhere. */

/* Thin (wght 300) Material 'close' glyph for dialog dismiss buttons, per the
   Figma dialog spec. Inlined as a 1KB data URI so it ships inside the bundle:
   a cached/stale gfonts.css cannot silently drop the face and fall back to
   the thick wght-400 X. */
@font-face {
  font-family: 'Material Symbols Outlined Thin';
  font-style: normal;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}

html {
    scroll-behavior: smooth;
}

body {
    margin: 0;
    color: var(--black-85);
    background: var(--panel-bg-level-0);
    font-family: 'Inter', sans-serif;
    box-sizing: border-box;
    letter-spacing: 0.02em;
    /* Figma renders text grayscale-antialiased; macOS subpixel AA makes the
       same weights read heavier/brighter on dark backgrounds. */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

div {
    padding: 0;
    border: 0;
    margin: 0;

    text-overflow: clip;
    box-sizing: border-box;
    background-clip: border-box;
}

/* SearchBox is contenteditable rather than an input. Keep its text/caret on
   one vertical axis everywhere; individual surfaces only own width, colors,
   and the horizontal room reserved for their search icon. */
.searchbox-control[data-searchbox] {
    padding-top: 0;
    padding-bottom: 0;
    /* A line box is needed even when the editable control is empty; flex
       centers placeholder text but leaves an empty contenteditable caret at
       the top. 30px is the 32px control less its 1px borders. */
    line-height: 30px;
}

.search:has(> .searchbox-control.searchbox[data-searchbox]) {
    position: relative;
}

.search:has(> .searchbox-control.searchbox[data-searchbox]) > .icon {
    top: 50%;
    transform: translateY(calc(-50% + 2px));
}

:focus-visible {
    outline: none;
}

::-webkit-scrollbar { 
    width: 7px;
    height: 7px;
}
::-webkit-scrollbar-thumb { 
    background: var(--black-25);
    border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
    filter: brightness(1.2);
}
::-webkit-scrollbar-corner {
    background-color: #00000000;
}

:root {
    --panel-bg-level-0: #101820;
    --black_10:#040608;
    --black-00: var(--panel-bg-level-0);
    --black-02: #171F27;
    --black-03:#182027;
    --black-05:#1c242b;
    --black-07:#22282f;
    --black-10:#282f36;
    --black-15:#343b41;
    --black-20:#40464d;
    --black-25:#4c5258;
    --black-30:#575d62;
    --black-35:#64696e;
    --black-45:#7c8084;
    --black-50:#878b8f;
    --black-65:#abaeb1;
    --black-75:#c3c5c7;
    --black-80:#cdcdce;
    --black-85:#dbdcde;
    --black-90:#e7e8e9;
    --node-bg:#343b43;
    --blue-1:#2c3a74;
    --blue-2:#5a6ccd;
    --hover-fg: var(--black-65);
    --hover-bg: var(--black-15);
    /* Hover highlight for anything clickable that paints its own surface. A
       layer over background-color, not box-shadow or filter: those would erase
       the elevation shadows in chains and group descendants into one rendering
       context. Read-only elements get no hover at all. */
    --hover-veil: rgba(255,255,255,0.06);
    /* Half strength, for surfaces large enough that the full veil reads as a
       selection instead of a hover. Node cards on the devices screen. */
    --hover-veil-soft: rgba(255,255,255,0.03);
    /* Same job for a bare glyph or label, which has no surface to layer over.
       Relative, because a fixed target colour would dim anything already near
       the top of the scale. Only for leaf elements: filter groups descendants. */
    --hover-lift: 1.15;
    --red-1: #58292d;
    --red-2: #B72828;
    --red-3: #ec736a;
    --green-1: #49c97c;
    /* Warm sand, same ink as the slot pocket edge in chain.css. Marks a
       non-production build. */
    --amber-1: #f4d09f;
    --dark-red: #28161c;

    /* Dialog/button tokens from the Figma dialog spec (ProPatch v1.0 "GUI
       Refactor"); names match Wolffhound's index.css so the two apps share
       one vocabulary. */
    --ui-modal-bg: #293037;
    --ui-modal-radius: 4px;
    --ui-modal-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
    --ui-modal-header-height: 34px;
    --ui-modal-header-bg: #485cc7;
    /* Gosta (round 3): everything reddish becomes the pastel/pinkish red,
       CHAIN INVALID included. The deep red in node 3495:40284 is an outdated
       raster. Header and button share the color on red dialogs. */
    --ui-modal-header-bg-danger: var(--red-3);
    --ui-modal-header-text-danger: var(--black-20);
    /* Dialog primary is deliberately brighter than the #485cc7 header: "the
       button and the header are the same for the red, different for the blue"
       (design review round 3 pt2). */
    --ui-button-bg-primary: #6e80e0;
    /* Round 4 (Gosta): primary button text matches the modal background. */
    --ui-button-text-primary: var(--ui-modal-bg);
    --ui-button-border-secondary: var(--black-65);
    --ui-button-text-secondary: var(--black-65);
}

[data-sonner-toast] {
    transition: height 200ms ease, box-shadow 200ms ease, opacity 200ms ease;
}
.toast {
    font-size: 13px;
    text-align: left;
    display: flex;
    align-items: center;
    animation: toast-in 150ms ease;
}
@keyframes toast-in {
    from { opacity: 0.5; }
    to   { opacity: 1; }
}
.toast-icon {
    font-size: 16px;
    opacity: 0.6;
}
.toast-body {
    margin-left: 8px;
}
.toast-label {
    font-weight: 600;
}
.toast-verb {
    opacity: 0.6;
}
.toast-note {
    opacity: 0.4;
    font-size: 12px;
}
.toast-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
}
.toast-header-label {
    font-weight: 600;
    opacity: 0.5;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
.toast-header-note {
    opacity: 0.4;
}
.toast-divider {
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding-bottom: 6px;
    margin-bottom: 6px;
}
.toast-row {
    display: flex;
    align-items: center;
}

.symbols {
    font-family: 'Material Symbols Outlined';
    user-select: none;
}

.mui-icons {
    font-family: 'Material Icons';
}

.acticon { 
    border-radius: 4px;
    font-size: 24px;

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    user-select: none; 
}

.acticon:hover {
    filter: brightness(1.4);
}

.tridot {
    font-size: 24px;
    width: 24px;
    line-height: 0.95;
    cursor: pointer;
    user-select: none;
    font-family: 'Material Symbols Outlined';
    /* the more_vert ink sits ~1.5px high in its line box: nudge the glyph
       itself, wherever a box centers it (measured on the 40px browser rows:
       11px over / 13.5px under before the shift) */
    position: relative;
    top: 1.5px;
}

.tridot:hover {
    filter: brightness(1.3);
}

#propatch-model {
    position: absolute;
    top: 20px;
    left: 21px;
    font-size: 16px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.02em;
    color: white;
    cursor: pointer;
    user-select: none;
}

#propatch-model:hover {
    color: var(--black-90);
}

/* The build stamp rides on the model number's baseline: the 12px gap between
   the title and #browser-main has no room for a line of its own. */
#propatch-model .model-line {
    display: flex;
    align-items: baseline;
    gap: 7px;
}

/* 10px keeps the longest case (PP128R + a two-digit minor) clear of the
   session selector, which starts at 192px */
#build-stamp {
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0;
    white-space: nowrap;
}

/* .version inherits the title's colour, hover included */
#build-stamp .version,
#build-stamp .build,
#build-stamp .channel {
    display: inline;
}

#build-stamp .build {
    color: var(--black-35);
}

#build-stamp .channel {
    color: var(--amber-1);
    text-transform: uppercase;
}

#session {
    /* Figma "text input" session selector is 188x32 (node 3463:60747) */
    width: 188px;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
}

#friendly {
    width: 180px;
    height: 100%;
    margin-right: 16px;

    font-size: 15px;
    border-radius: 4px;

    background-color: var(--black-10);

    display: flex;
    text-align: left;
    align-items: center;
}

#friendly.undefined {
    background-color: var(--red-3);
    color: var(--black-20);

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

#friendly.undefined.connected {
    background-color: var(--green-1);
}

#friendly .name {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 75%, transparent 100%);
}

#friendly.defined .name {
    padding-left: 10px;
}

#friendly.defined .name::before {
    font-family: 'Material Icons';
    font-size: 13px;
    color: var(--red-3);
    content: 'circle';
    padding-right: 6px;
}

#friendly.defined.connected .name::before {
    color: var(--green-1);
}

#friendly .name.edit {
    background-color: var(--black_10);
    color: var(--black-90);
    border: var(--black-90) solid 1px;
    border-radius: 4px;
    text-overflow: clip;
}

#chain-new,
#device-new {
    /* Gosta (round 6): one 20px inset for all tabs/buttons and chains */
    margin-left: 20px;
}

#device-new {
    background-color: green;
}

#chain-new .symbol,
#device-new .symbol {
    /* Figma plus glyph sits in a 24px slot with 8px padding (node 3463:60746) */
    font-size: 20px;
}

.symbol {
    display: inline;
    font-family: 'Material Symbols Outlined';
    /* Figma header icons use the regular Material Symbols grade (node
       3463:60746); 800 was synthesizing a faux bold. */
    font-weight: 400;
}

#top-icons {
    /* Figma header: session selector at x=192, controls at y=18, settings
       gear box 25px off the right edge (node 3463:60740, frame 1499 wide,
       gear box 1446+28). WH's titlebar logo shares the same 25px inset. */
    margin-left: 192px;
    margin-right: 25px;
    margin-top: 18px;
    height: 32px;
    max-height: 32px;
    display: flex;
    justify-content:space-between;
    align-items: center;
}

.top.cta {
    /* Figma header buttons: 12px sides, 4px vertical, 4px icon-label gap
       (node 3463:60742). The gap replaces the old &nbsp; spacing. */
    padding: 4px 12px;
    gap: 4px;
    height: 100%;
}

#top-left, #top-right {
    height: 32px;
    max-height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
}

#top-right {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content:space-between;
}

#midi-over {
    display: none;
    position: absolute;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0,0,0,0.5);
    z-index: 1;
    backdrop-filter: blur(0.8px);
}

/* Figma "btn MIDI/shortcut" variant (node 3463:60742): outline, no fill */
#shortcuts {
    margin-right: 20px;
    background-color: transparent;
    outline: 1px solid var(--blue-1);
    outline-offset: -1px;
}

#shortcuts .symbol {
    /* the cmd glyph inks 0.75 of its em box; the design's icon ink is 17.5px
       (node 2351:40963, 17.5px mask in a 24px slot) — 23px em lands there */
    font-size: 23px;
}

/* Figma gives every header-button icon a 20px slot and lets the ink spill
   over it (buttons hug to 126/76/116); without the clamp the bigger glyphs
   widen the buttons */
#shortcuts .symbol,
#mute-all .symbol {
    width: 20px;
    display: inline-flex;
    justify-content: center;
    overflow: visible;
}

#midi .midi-port-icon {
    margin: 0 -2px;
}

#midi {
    margin-right: 20px;
    position: relative;
    pointer-events: none;
    filter: brightness(0.7);
}

#midi.enabled {
    filter: brightness(1);
    pointer-events: all;
}

/* Offline MIDI is an active route to Configuration, while a connected MIDI
   button remains gated by the current chain/MIDI-Learn eligibility. */
#midi.midi-bad {
    pointer-events: all;
}

#midi.enabled.selected {
    filter: brightness(1.1);
    outline: 2px solid var(--black-80);
    z-index: 2;
}

#chain-new:hover,
#device-new:hover,
.devcfg .node-new:hover,
#shortcuts:hover,
#midi:hover,
#mute-all:hover {
    filter: brightness(1.3);
}

.midi-ports .port {
    color: var(--black-65);
}

.midi-ports .port.selected {
    color: var(--black-80);
}

.midi-ports .port.bad {
    font-style: italic;
    color: var(--black-45);
}

.midi-learn {
    z-index: 2;
    pointer-events: all;
}

.midi-learn.learning {
    animation: pulse-fg 0.3s ease-in-out infinite;
}

@keyframes pulse-fg {
    0%, 100% {
        outline-width: 0.1px;
        outline-color: rgba(147, 55, 255, 0);
        filter: brightness(0.8);
    }
    50% {
        outline-width: 3px;
        outline-color: rgba(147, 55, 255, 0.5);
        filter: brightness(1);
    }
}

.midi-learn::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 120cqw;
    height: 120cqh;
    background: rgb(147, 55, 255);
    transform: translate(-50%, -50%);
    animation: pulse-bg 1.5s ease-in-out infinite;
    z-index: 2;
}

.midi-learn.learning::after {
    animation: pulse-bg 0.3s ease-in-out infinite;
}

@keyframes pulse-bg {
    0%, 100% {
        opacity: 0;
    }
    50% {
        opacity: 0.65;
    }
}

#mute-all .symbol {
    /* the power glyph's ink is 20/24 of its em box; the design's icon ink is
       17.5px in the 32px button (node 2351:40765) — 21px em lands exactly there */
    font-size: 21px;
}

#mute-all {
    position: relative;
    height: 32px;
    /* Figma fixes this button at 116px, 19px before the gear (nodes
       3463:60745 / 3463:60752). */
    width: 116px;
    background-color: var(--red-1);
    margin-right: 19px;
}

#system-menu {
    height: 28px;
    width: 28px;
    box-shadow: none;

    border-radius: 4px;

    background: transparent;

    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1.3;

    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    overflow: hidden;
}

/* Figma gear fill is #CDCDCE (node 3463:60752); the glyph is an SVG child */
#system-menu .tridot {
    color: var(--black-80);
    display: flex;
    align-items: center;
    /* the SVG is its own ink — the text-glyph nudge on .tridot must not move it */
    top: 0;
}

#system-menu.update .tridot {
    animation: system-menu 600s ease-in-out infinite;
}

@keyframes system-menu {
    0%,0.25%,0.5% { transform: scale(1); }
    0.125%,0.375% { transform: scale(1.4); }
}

#system-menu:hover {
    background: rgba(255, 255, 255, 0.1);
}

/* Match the neighboring header buttons by lightening the gear ink on hover. */
#system-menu:hover .tridot {
    filter: brightness(1.3);
}

#system-menu.update {
    width: 100px;
    justify-content: right;
    background-color: var(--blue-1);
}

#system-menu.update .text {
    font-size: 17px;
}

/* soft, sweeping highlight */
.shimmer {
    position: relative;
    overflow: hidden;
    background-color: #1F2937;
    color: #D1D5DB;
}

.shimmer::before {
    content: '';
    position: absolute;
    top: 0;
    left: -120%; /* Start off-screen */
    width: 50%;
    height: 100%;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.14), /* faint white highlight */
        transparent
    );
    transform: skewX(-25deg); /* Skews the light source for a more dynamic look */
    animation: shimmer 600s ease-in-out infinite;
}

@keyframes shimmer {
    0%,1%,2%,100% { left: -120%; }
    0.5%,1.5% { left: 120%; }
}

#space {
    position: fixed;
    top: 70px;
    left: 380px;
    right: 0;
    height: calc(100vh - 72px - 5px);
    overflow: hidden;
}

/* Every workspace uses the external right rail: an 8px thumb remains
   centered in 20px between the content frame and the window edge. */
#space > *::-webkit-scrollbar {
    width: 20px;
}

#space > *::-webkit-scrollbar-thumb {
    border: 6px solid transparent;
    background-clip: padding-box;
    /* The painted radius is border-radius minus the border, so 10px keeps the
       visible 8px thumb a full pill (Gosta, Aug 4) */
    border-radius: 10px;
}

#space.midi-learning {
    z-index: 1;
}

/* The screen is pointer-disabled during MIDI Learn, but the native scroll
   container still needs to win wheel hit-testing. Keep its cards inert; the
   existing .midi-learn rule selectively re-enables eligible controls. */
#space.midi-learning .chain-space {
    pointer-events: auto;
}

#space.midi-learning .chain-space > * {
    pointer-events: none;
}

/* Disconnected banner occupies y72..147; chains resume at 163 (Figma NODES VIEW) */
#screen.disconnected #space {
    top: 163px;
    height: calc(100vh - 165px - 5px);
    transition: top 0.2s ease, height 0.2s ease;
}

/* Collapsed banner is head-only (ends at y112) — chains take the freed
   space, keeping the same 16px gap as the expanded state */
#screen.disconnected:has(.app-banner.collapsed) #space {
    top: 128px;
    height: calc(100vh - 130px - 5px);
}

.menu {
    position: absolute;
    z-index: 100;
    border-radius: 2px;
    background: var(--black-07);
    padding: 6px 6px 6px 6px;
    width: 160px;
}
  
.menu .item  {
    position: relative;
    height: 32px;
    padding-left: 10px;
    color: var(--black-80);
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
}

.menu .item.submenu {
    height: 38px;
    padding-top: 4px;
}
  
.menu .item.divider {
    border-top: 1px solid var(--black-30);
}

.menu .item:hover {
    color: var(--black-90);
    background: var(--hover-bg);
}

.menu .item.submenu::after {
    content: '>';
    position: absolute;
    right: 10px;
    font-size: 16px;
    color: var(--black-90);
}

.menu .item .submenu  {
    display: none;
    position: absolute;
    z-index: 100;
    top: 0px;
    left: -174px;
    border-radius: 4px;
    background: var(--black-07);
    padding: 3px 8px 6px 8px;
}

.menu .item .submenu .item .submenu  {
    display: none;
    position: absolute;
    z-index: 100;
    top: 0px;
    left: -100px;
    border-radius: 4px;
    background: var(--black-07);
    padding: 3px 8px 6px 8px;
}

.menu .item:hover .submenu  {
    display: block;
}

.menu .item .submenu .item:hover .submenu   {
    display: block;
}

.menu .submenu .item {
    color: var(--black-65);
}

.menu .submenu .item:hover {
    color: var(--black-90);
}

.menu .item .choice  {
    padding-right: 8px;
}

.menu .item .owner {
    color: var(--black-45);
}

.menu .item.hilite .choice {
    color: var(--black-90);
}

.hidden { display: none; }

#ingest-errors {
    position: fixed;
    z-index: 999;
    width: 90vw;
    height: 50vh;
    top: 25vh;
    height: 50vh;
    left: 5vw;
    border-radius: 5px;
    background: white;
    color: black;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
  
  #ingest-errors pre {
    padding-left: 10px;
    height: 40vh;
    font-size: 17px;
    color: black;
    overflow: scroll;
  }
  
  #ingest-errors button {
    display: flex;
    color: black;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    width: 80px;
  }

#screen {
    height: 100vh;
    width: 100vw;
    min-width: 1036px;
    background: var(--panel-bg-level-0);
    position: relative;
    overflow: hidden;
}

#screen.disconnected {
    background: var(--panel-bg-level-0);
}
  
.midi-channel.selected .reserved {
    padding-left: 10px;
    opacity: 60%;
    width: 100%;
}

.note.selected .reserved {
    padding-left: 10px;
    color: var(--black-80);
    width: 100%;
}

.browser-device {
    position: relative;
    width: 320px;
    height: 40px;
    display: flex;
    background-color: var(--black-10);
    align-items: center;
    color: var(--black-80);
    border: 1px solid #00000000;
}

.browser-device:hover {
    color: var(--black-90);
    border-color: var(--black-35);
}

.browser-device.selected {
    border-color: var(--black-45);
}

.browser-device .name {
    position: absolute;
    left: 10px;
    width: 100%;

    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0.26px;
    color: var(--black-65);

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 75%, transparent 100%);
}

.browser-device.selected .name {
    color: var(--black-90);
    font-weight: bold;
}

.browser-device .popup {
    position: absolute;
    top: 8px;
    right: 1%;

    font-size: 24px;
}

.browser-module {
    border-radius: 2px;
    position: relative;
    height: 40px;
    width: 320px;

    display: flex;
    background-color: var(--node-bg);

    align-items: center;
}

/* Node browser rows are drag sources, so they react to the pointer. The drag
   wrapper is transparent; the row background lives on .browser-module. Matches
   .browser-device, which already had a hover. */
.browser .isolatable:hover .browser-module {
    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));
}

.browser-module.invalid {
    background: var(--red-1);
}

.browser-module .popup {
    font-size: 24px;
    position: absolute;
    top: 8px;
    right: 3px;
}

.popup-menu .menu-list .menu-item.octave {
    display: block; 
    text-align: right; 
}

.browser-module.submodule {
    /* Figma nested/sub rows are a step darker than --black-10 (raw hex in the
       design, node 3463:60739) */
    background-color: #242a30;
}

.browser-module .expander {
    position: absolute;
    right: 83px;
    width: 18px;

    color: var(--black-65);

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    user-select: none; 
}

.browser-module.invalid .expander {
    color: var(--black-45);
}

.browser-module .device  {
    position: relative;
    left: 12px;
    top: -8px;
    /* Figma text block is fixed 265px (node 3463:60739) */
    width: 265px;

    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0.26px;
    color: var(--black-65);

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 80%, transparent 100%);
}

.browser-module.invalid .device  {
    color: var(--black-45);
    font-style: italic;
}

.browser-module.stereo .device {
    width: 210px;
}

.browser-module.m2s .device  {
    width: 230px;
}

.browser-module .name {
    position: absolute;
    bottom: 3px;
    left: 12px;
    width: 260px;

    font-size: 13px;
    color: var(--black-65);

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 80%, transparent 100%);
}

.browser-module.invalid .name {
    color: var(--black-45);
    font-style: italic;
}

.browser-module.stereo .name {
    width: 210px;
}

.browser-module.m2s .name {
    width: 240px;
}

.browser-module .channels {
    position: absolute;
    right: 24px;
    height: 100%;

    font-size: 11px;

    white-space: nowrap;
    text-overflow: clip;

    text-align: center;
    display: flex;
    justify-content: right;
    align-items: center;
}

.browser-module .channels .channel {
    height: 26px;
    width: 26px;

    font-weight: normal;

    border-radius: 26px;
    color: var(--black-80);
    background-color: var(--black-25);

    box-shadow: 0 0 1px var(--black-05);

    font-size: 13px;

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.browser-module.invalid .channels .channel {
    color: var(--black-45);
}

.browser-module .channels .channel.used {
    color: var(--black-05);
    font-weight: 500;
}

.browser-module .channels .channel.m2s {
    position: relative;
    width: 42px;
    font-size: 12.5px;
}

.browser-module .channels .channel.stereo.L {
    margin-right: 3px;
}

/* DOUBLE-CLICK an L/R chip to add just that channel */
.browser-module .channels .channel.choosable {
    cursor: pointer;
}

.browser-module .inuse {
    position: absolute;
    left: 306px;
    width: 51px;
    height: 24px;
    font-size: 0px;

    display: flex;

    text-align: center;
    justify-content: center;
    align-items: center;

    visibility: hidden;
}

.browser-module.used .inuse {
    font-size: 13px;
    font-weight: bold;

    visibility:visible;
}

.browser-module .popup {
    font-size: 22px;
    color: var(--black-65);
}

#browser-main {
    width: 360px;
    align-content: start;
    top: 70px;
    position: absolute;
    left:20px;
    background-color: var(--black-05);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    height: 42px;
    overflow-x: visible;
}

#browser-main .types {
    padding-top: 12px;
    /* tabs live in the panel's content frame: the first icon starts on the
       content axis, the last tab ends flush with the search box's right edge */
    padding-left: 20px;
    padding-right: 20px;

    color: var(--black-45);

    display:flex;
    text-align: center;
    justify-content: space-between;
    align-items: center;
}

#browser-main .types .choice .svgicon {
    display:flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding-right: 4px;
}

#browser-main .types .choice {
    font-size: 16px;
    font-weight: 500;

    cursor: pointer;
    user-select: none;

    display:flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

#browser-main .types .choice .symbols {
    font-size: 20px;
    /* the icon font only ships wght 400; a heavier label weight would
       synthesize a thicker glyph */
    font-weight: 400;
    padding-right: 3px;
    vertical-align: middle;
}

/* the flowchart glyph carries ~1.7px of left bearing inside its em box
   (canvas actualBoundingBoxLeft); pull the first tab back so the visible
   ink, not the box, starts on the content axis */
#browser-main .types .choice:first-child .symbols {
    margin-left: -2px;
}

#browser-main .types .choice:hover {
    color: var(--black-80);
}

#browser-main .types .choice.selected {
    color: var(--black-85);
}

#browser-main .types .choice .svgicon .fill {
    fill: var(--black-45);
}

#browser-main .types .choice:hover .svgicon .fill {
    fill: var(--black-80);
}

#browser-main .types .choice.selected .svgicon .fill  {
    fill: var(--black-85);
}

#browser {
    width: 360px;
    align-content: start;
    top: 112px;
    position: absolute;
    left:20px;
    background-color: var(--black-05);
    /* #browser-main's tab strip sits on top of this surface: rounding the
       top corners here notched the panel's edge at the seam (Gosta's
       "round corner bug") — only the strip rounds the top, only this
       surface rounds the bottom */
    border-radius: 0 0 4px 4px;
    height: calc(100vh - 116px - 5px);
    overflow-x: visible;
}

.browser {
    position: relative;
    display:flex;
    flex-direction: column;
    background-color: var(--black-30);
    align-items: center;
    overflow: visible;
}

.browser .search-hr {
    width: 320px;
    height: 1px;
    margin-bottom: 14px;
}

.browser .tag-hr {
    width: 320px;
    height: 1px;
    background-color: var(--black-25);
    margin-top: 8px;
    margin-bottom: 8px;
}

/* One content axis for the panel (Gosta, round 6): search, pills, type tabs
   and rows all share the rows' frame — 20px from the panel's left edge, 328px
   wide — instead of each centering to its own width; the scrollbar keeps its
   own gutter to the right of that frame */
.browser .search,
.browser .filters,
.browser .types,
.browser .search-hr,
.browser .tag-hr {
    align-self: flex-start;
    margin-left: 20px;
}

.browser .search {
    margin-top: 4px;
}

.browser .search .icon {
    position: absolute;
    left: 10px;
    font-size: 22px;
    color: var(--black-45);
    user-select: none;
}

.browser .searchbox {
    font-size: 15px;

    width: 320px;
    height: 32px;
    /** if missing, caret appears in upper left of searchbox when empty (and focused) */
    padding: 0 5px;
    padding-left: 38px;

    color: var(--black-65);
    background-color: var(--black-10);

    border: solid var(--black-15) 1px;
    border-radius: 4px;

    /** prevents default outlining of active input text box */
    outline: none;

    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    overflow: hidden;
}

.browser .searchbox.hidden {
    display: none;
}
  
.browser .searchbox.empty {
    color: var(--black-35);
    user-select: none;
}

.browser .searchbox.edit {
    font-style: normal;
    text-overflow: clip;
    overflow: hidden;
    color: var(--black-80);
    background-color: var(--black-20);
}

.browser.module .types {
    color: var(--black-45);

    margin-top: 14px;
    margin-bottom: 0px;

    height: 100%;
    max-height: 24px;

    display: flex;
    align-items: center;
    gap: 18px;
}

.browser .types .choice {
    font-size: 15px;
    letter-spacing: 0;

    cursor: pointer;
    user-select: none;

    display:flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.browser .types .choice:hover {
    color: var(--black-80);
}

.browser .types .choice.selected {
    color: var(--black-85);
}

.browser .types .choice .svgicon {
    display:flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.browser .types .choice .svgicon .fill {
    fill: var(--black-45);
}

.browser .types .choice:hover .svgicon .fill {
    fill: var(--black-80);
}

.browser .types .choice.selected .svgicon .fill  {
    fill: var(--black-85);
}

.browser .filters {
    width: 320px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 15px;
    margin-bottom: 4px;
}

.browser .header .type {
    position: absolute;
    left: 5px;

    font-size: 18px;
    font-weight: bold;
    color: var(--black-85);

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;

    user-select: none; 
}

.browser .header .sort,
.browser .header .active {
    height: 22px;
    border-radius: 4px;

    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.3px;

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    user-select: none;
}

/* Figma sort row: plain 12px label + arrow, no pill (node 16:17337) */
.browser .header .sort {
    color: var(--black-65);
    background-color: transparent;
    gap: 2px;
}

.browser .header .sort .symbols {
    font-size: 16px;
}

/* The filter is always on, only its label changes, so the pill stays light in
   all three states the way prod has it (Gosta, July 20) */
.browser .header .active {
    width: 75px;
    padding-left: 12px;
    padding-right: 10px;
    color: var(--black-05);
    background-color: var(--black-80);
}

.browser .header .sort:hover {
    color: var(--black-80);
}

.browser .header .active:hover {
    color: var(--black-05);
    background-color: var(--black-65);
}

.browser .header {
    width: 320px;
    margin-bottom: 8px;

    font-size: 22px;

    display: flex;
    text-align: center;
    justify-content:space-between;
    align-items: center;
}

.browser .header > .left {
    display: flex;
    text-align: center;
    justify-content: left;
    align-items: center
}

.browser .header > .right {
    display: flex;
    text-align: center;
    justify-content: left;
    align-items: center;
}

.chain.browser .header .fave {
    margin-left: 10px;
    height: 22px;
    color: var(--black-35);
}

.chain.browser .header .fave.selected {
    color: var(--black-80);
}

.chain.browser .header .fave:hover {
    color: var(--black-65);
}

.chain.browser .header .normal {
    font-size: 23px;
    height: 22px;
    margin-left: 13px;
    color: var(--black-35);
}

.chain.browser .header .normal.selected {
    color: var(--black-80);
    font-weight: bold;
}

.chain.browser .header .normal:hover {
    color: var(--black-65);
}

.browser .results {
    position: relative;
    flex-grow: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    /* pinned to the content axis like .search/.filters above: without
       align-self the panel centers the margin box and the left edge drifts
       with the width (39 here, 43.5 in the chain browser) */
    align-self: flex-start;
    margin-left: 20px;
    /* 320px content + 14px so the 8px scrollbar centers in the right 20px
       gutter: 6px off the rows, 6px off the panel edge (Gosta, round 6) */
    width: 334px;
}

.browser .results::-webkit-scrollbar {
    width: 8px;
}

.browser .results .items {
    width: 320px;
}

.browser .results .items .item {
    /* Figma list rhythm: 40px row + 4px gap (node 3463:60739) */
    min-height: 44px;
    padding: 2px 0;
}

/* The scrollbar track starts at the results box: zero only the actual first
   card's top padding so the thumb starts level with it. Node rows have an
   extra wrapper, so a descendant :first-child would match every Node row and
   collapse their intended 4px rhythm to 2px. */
.browser .results .items > .item:first-child,
.browser.module .results .items > :first-child > .item:first-child {
    padding-top: 0;
    min-height: 42px;
}

/* The device browser is a flush list (ProPatch 1.5 ref): rows touch,
   the zebra alone separates them; nodes and chains keep the carded
   4px rhythm — gaps mark rows as draggable objects, and node shades
   carry meaning only inside chains (Jared, Figma round 6).
   Content frame is 320px: 20px inset on BOTH panel edges (Gosta), the
   scrollbar centers in the right 20px gutter */
.browser.device .results .items .item {
    min-height: 40px;
    padding: 0;
}

.browser.device .results .items .item:nth-child(odd) .browser-device {
    background-color: var(--black-15);
}

.browser .results .items .item .subitem  {
    min-height: 42px;
    display: none;
}

.browser .results .items .item .subitem.expanded {
    display: block;
}

.browser .results .items .item .subitem.expanded.top {
    margin-top: 2px;
}

.browser .results .items .empty {
    height: 42px;
    padding-right: 40px;

    font-size: 14px;
    font-style: italic;
    color: var(--black-45);

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;

    user-select: none; 
}

.browser.device > .cta.new {
    left: 21px;
}

#controls {
    display: flex;
    gap: 14px;
    top: 10px;
    position: absolute;
    left:506px;
}

/* App-chrome CTA per Figma "btn cta primary" (node 3463:60746): #2c3a74 fill,
   light text. Dialog CTAs are recolored in widgets.css to the dialog spec. */
.cta {
    height: 32px;
    padding-left: 16px;
    padding-right: 16px;
    border-radius:4px;
    background-color: var(--blue-1);

    box-shadow: none;

    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: var(--black-90);

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    user-select: none;

    white-space: nowrap;
    overflow: hidden;
}

.cta:hover {
    color: var(--black-65);
}

.cta.secondary {
    color: var(--ui-button-text-secondary);
    outline: 1px solid var(--ui-button-border-secondary);
    outline-offset: -1px;
    background-color: transparent;
}

.cta.secondary:hover {
    color: var(--black-80);
    background-color: transparent;
}

/* Active but deliberately de-emphasized actions, such as “Don't save”. */
.quiet {
    opacity: 0.72;
}

.quiet:hover {
    opacity: 1;
}

.modal.modtype .options {
    display: flex;
    gap: 22px;
    justify-content: space-around;
    padding-left: 22px;
    padding-right: 22px;
    padding-top: 20px;
}

.modal.modtype .options .option {
    font-size: 48px;
    height: 130px;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 4px;
    background-color: var(--black-15);

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    user-select: none; 
}

.popup {
    user-select: none; 
    cursor: pointer;
}

/* The container is a pure positioning box — the rounded .menu-list inside
   draws the border and shadow, so a square outline never peeks out. */
.popup-menu {
    visibility: hidden;
    position: absolute;
    transition: opacity 0.2s ease-in-out;
    background-color: transparent;
}

.popup-menu > .menu-list {
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.popup-menu:hover {
    display: block;
}
  
.menu-list,
.submenu-list {
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
    list-style: none;
    margin-top: 5px;
    /* match the 5px side insets so the first item's top gap reads the same */
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    background-color: var(--black-00);
    border: 1px solid var(--black-10);
}

.menu-item {
    position: relative;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 7px;
    padding-bottom: 7px;
    border-radius: 2px;

    color: var(--black-80);
    font-weight: 500;

    cursor: pointer;
    user-select: none;;
    white-space: nowrap;

    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* invisible hover zones extending from parent menu items */
.menu-item.cascade::before {
    content: '';
    position: absolute;
    top: -8px;
    bottom: -8px;
    left: -8px;
    right: -15px; /* Extend further right toward submenu */
    z-index: -1;
    pointer-events: auto;
  }

  .submenu-list::before {
    content: '';
    position: absolute;
    top: -8px;
    bottom: -8px;
    left: -15px; /* Connect back to parent menu */
    right: -8px;
    z-index: -1;
    pointer-events: auto;
  }

  /* Increase hit area for cascade items */
  .submenu-list {
    padding-left: 5px;
    padding-right: 4px;
  }

  /* Create invisible connection between submenu and parent */
.menu-list::after,
  .submenu-list::after {
    content: '';
    position: absolute;
    top: -20px;
    bottom: 0;
    left: -10px; /* Invisible bridge from parent */
    width: 20px;
    pointer-events: auto;
    z-index: 1;
  }

.menu-item.midi {
    justify-content: left;
    padding-top: 6px;
    padding-bottom: 6px;
    color: var(--black-65);
}

.menu-item.midi .svgicon {
    padding-top: 4px;
}

.menu-item.disabled {
    color: var(--black-45);
    font-weight: normal;
}
  
.menu-item.shimmer {
    background-color: var(--black-10);
    border-radius: 2px;
    color: #7db4f0;
}

.menu-item.active:hover {
    background: var(--black-20);
}

.menu-item.cascade:hover {
    background: var(--black-20);
}

.menu-item.div-top {
    border-top: 1px solid var(--black-30);
}

.menu-item.div-bottom {
    border-bottom: 1px solid var(--black-30);
}
  
.menu-item:has(+ .div-top) {
    padding-top: 10px;
    padding-bottom: 11px;
}

.menu-item.cascade::after {
    position: relative;
    right: -4px;
    font-family: 'Material Symbols Outlined';
    font-size: 11px;
    font-weight: bold;
    content: "arrow_forward_ios";
    margin-right: 0px;
    color: var(--black-90);
}

.menu-item.cascade.empty::after {
    color: var(--black-45);
}

.menu-item.cascade.disabled::after {
    color: var(--black-45);
}

.menu-item.cascade.empty {
    color: var(--black-45);
}

.submenu-list {
    position: absolute;
    visibility: hidden;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
    margin-left: 5px;
    z-index: 1000;
}
  
.menu-item:hover > .submenu-list {
    min-width: 40px;
    visibility: visible;
}

.newmod .name.editbox {
    font-size: 18px;
    height: 28px
}

.modal .newmod .prompt {
    color: var(--black-65);
    font-size: 20px;
}

.modal .newmod .header {
    font-size: 16px;
    color: var(--black-65);
}

.modal .newmod .options {
    padding: 10px;
    background-color: var(--black-05);
}

.modal .newmod .option.selected {
    background-color: var(--black-15);
    color: var(--black-90);
}

.modal .newmod .cta.disabled {
    background-color: var(--black-15);
    color: var(--black-30);
}

.modal .newmod .option.disabled{
    color: var(--black-35);
}

.modal .newmod .option:hover {
    background-color: var(--black-25);
}

.midi-event {
    z-index: 10;
    border-radius: 32px;
    visibility: hidden;
    border: 5px solid var(--black-45);

    font-weight: 500;
    color: var(--black-80);

    background-color: rgb(0 0 0 / 0.6);

    position: absolute;
    width: 250px;
    height: 250px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    animation: fadeOut 1.2s ease-in;

    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;

    pointer-events: none;
}

.midi-event .note {
    font-size: 100px;
    height: 100px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.midi-event .channel {
    font-size: 38px;
    height: 40px;

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.midi-event .state {
    font-size: 42px;
    height: 60px;

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.midi-event .ts {
    font-size: 8px;
    color: var(--black-45);
}

.midi-event::after {
    position: absolute;
    font-weight: normal;
    opacity: 0.3;
    font-family: 'Material Icons';
    font-size: 250px;
    content: 'music_note';
    color: var(--black-65);
}

@keyframes fadeOut {
    from { 
      visibility: visible; 
      opacity: 0.9;
    }
    to { 
      visibility: hidden; 
      opacity: 0; 
    }
}  

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;4CAE4C;;AAE5C;;;0BAG0B;AAC1B;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,4DAA68C;AAC/8C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,mCAAmC;IACnC,gCAAgC;IAChC,sBAAsB;IACtB,sBAAsB;IACtB;gEAC4D;IAC5D,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,SAAS;IACT,SAAS;;IAET,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;;4DAE4D;AAC5D;IACI,cAAc;IACd,iBAAiB;IACjB;;gEAE4D;IAC5D,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,uCAAuC;AAC3C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,mCAAmC;IACnC,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;IAC3B;;;yDAGqD;IACrD,oCAAoC;IACpC;wEACoE;IACpE,yCAAyC;IACzC;;iFAE6E;IAC7E,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB;8BAC0B;IAC1B,kBAAkB;IAClB,mBAAmB;;IAEnB;;wBAEoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,iDAAiD;IACjD,8BAA8B;IAC9B,6BAA6B;IAC7B;;kEAE8D;IAC9D,yCAAyC;IACzC,8CAA8C;IAC9C;;qCAEiC;IACjC,+BAA+B;IAC/B,uEAAuE;IACvE,4CAA4C;IAC5C,6CAA6C;IAC7C,2CAA2C;AAC/C;;AAEA;IACI,wEAAwE;AAC5E;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,OAAO,YAAY,EAAE;IACrB,OAAO,UAAU,EAAE;AACvB;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,eAAe;;IAEf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,wCAAwC;IACxC;;mDAE+C;IAC/C,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;mEACmE;AACnE;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;4CAC4C;AAC5C;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,yDAAyD;AACzD;;;IAGI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,oEAAoE;IACpE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;;IAElB,eAAe;IACf,kBAAkB;;IAElB,iCAAiC;;IAEjC,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;;IAEtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,oEAAoE;IACpE,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,4EAA4E;IAC5E,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,wCAAwC;IACxC;uDACmD;IACnD,gBAAgB;AACpB;;AAEA;IACI;;0EAEsE;IACtE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI;oEACgE;IAChE,iBAAiB;IACjB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,iCAAiC;IACjC,UAAU;IACV,4BAA4B;AAChC;;AAEA,0EAA0E;AAC1E;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI;4EACwE;IACxE,eAAe;AACnB;;AAEA;;sBAEsB;AACtB;;IAEI,WAAW;IACX,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;sEACsE;AACtE;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,UAAU;AACd;;AAEA;;;;;;IAMI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI;QACI,oBAAoB;QACpB,oCAAoC;QACpC,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,sCAAsC;QACtC,qBAAqB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,cAAc;IACd,6BAA6B;IAC7B,gCAAgC;IAChC,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;kFAC8E;IAC9E,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ;kCAC8B;IAC9B,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;;IAEhB,kBAAkB;;IAElB,uBAAuB;;IAEvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;;IAEhB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,4EAA4E;AAC5E;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,8EAA8E;IAC9E,MAAM;AACV;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gBAAgB,mBAAmB,EAAE;IACrC,gBAAgB,qBAAqB,EAAE;AAC3C;;AAEA;IACI,oCAAoC;AACxC;;AAEA,8EAA8E;AAC9E;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW,EAAE,qBAAqB;IAClC,UAAU;IACV,YAAY;IACZ;;;;;KAKC;IACD,wBAAwB,EAAE,mDAAmD;IAC7E,4CAA4C;AAChD;;AAEA;IACI,gBAAgB,WAAW,EAAE;IAC7B,YAAY,UAAU,EAAE;AAC5B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,QAAQ;IACR,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;oEACoE;AACpE;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B;qDACiD;IACjD,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;;wEAEwE;AACxE;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,mFAAmF;AACnF;IACI,UAAU;IACV,iCAAiC;IACjC,2CAA2C;AAC/C;;AAEA;2DAC2D;AAC3D;IACI,UAAU;IACV,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,UAAU,aAAa,EAAE;;AAEzB;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;AAEF;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,iCAAiC;IACjC,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;;IAEX,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;;IAEtB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;;IAET,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;;IAEZ,aAAa;IACb,gCAAgC;;IAEhC,mBAAmB;AACvB;;AAEA;;gDAEgD;AAChD;IACI,uEAAuE;AAC3E;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;iCAC6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;;IAEX,sBAAsB;;IAEtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,sDAAsD;IACtD,YAAY;;IAEZ,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;;IAEtB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;;IAEZ,eAAe;IACf,sBAAsB;;IAEtB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;;IAEZ,eAAe;;IAEf,mBAAmB;IACnB,mBAAmB;;IAEnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;;IAEX,mBAAmB;;IAEnB,mBAAmB;IACnB,sBAAsB;IACtB,iCAAiC;;IAEjC,mCAAmC;;IAEnC,eAAe;;IAEf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,sDAAsD;AACtD;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;;IAEd,aAAa;;IAEb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;;IAEjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,iCAAiC;IACjC,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB;+EAC2E;IAC3E,kBAAkB;IAClB,mBAAmB;;IAEnB,sBAAsB;;IAEtB,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;;IAEhB,eAAe;IACf,iBAAiB;;IAEjB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf;mCAC+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;iDAEiD;AACjD;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,iCAAiC;IACjC;;;kCAG8B;IAC9B,0BAA0B;IAC1B,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iCAAiC;IACjC,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;0CAG0C;AAC1C;;;;;IAKI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;;IAEf,YAAY;IACZ,YAAY;IACZ,mFAAmF;IACnF,cAAc;IACd,kBAAkB;;IAElB,sBAAsB;IACtB,iCAAiC;;IAEjC,iCAAiC;IACjC,kBAAkB;;IAElB,yDAAyD;IACzD,aAAa;;IAEb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;;IAEtB,gBAAgB;IAChB,kBAAkB;;IAElB,YAAY;IACZ,gBAAgB;;IAEhB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;;IAEjB,eAAe;IACf,iBAAiB;;IAEjB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;;IAET,eAAe;IACf,iBAAiB;IACjB,sBAAsB;;IAEtB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;;IAErB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;AACrB;;AAEA,sEAAsE;AACtE;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;0DAC0D;AAC1D;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,kBAAkB;;IAElB,eAAe;;IAEf,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB;;4DAEwD;IACxD,sBAAsB;IACtB,iBAAiB;IACjB;0EACsE;IACtE,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,4DAA4D;IAC5D,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;+CAG+C;AAC/C;;IAEI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;;;;+CAK+C;AAC/C;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;;IAEnB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;;IAEtB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;6EAC6E;AAC7E;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;;IAE/B,gBAAgB;;IAEhB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;;IAEtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;;IAEjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;IACtC,oDAAoD;IACpD,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA,yEAAyE;AACzE;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;;IAEjC,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;sEACsE;AACtE;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,yEAAyE;IACzE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;;IAElB,sBAAsB;IACtB,gBAAgB;;IAEhB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;;IAEnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,2DAA2D;AAC3D;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,YAAY,EAAE,wCAAwC;IACtD,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW,EAAE,gCAAgC;IAC7C,WAAW;IACX,WAAW;IACX,oBAAoB;EACtB;;EAEA,wCAAwC;EACxC;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,2DAA2D;AAC7D;;IAEI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW,EAAE,iCAAiC;IAC9C,WAAW;IACX,oBAAoB;IACpB,UAAU;EACZ;;AAEF;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;;IAEjC,gBAAgB;IAChB,sBAAsB;;IAEtB,kCAAkC;;IAElC,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,SAAS;IACT,gCAAgC;;IAEhC,+BAA+B;;IAE/B,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;;IAEZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;;IAEZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI;MACE,mBAAmB;MACnB,YAAY;IACd;IACA;MACE,kBAAkB;MAClB,UAAU;IACZ;AACJ","sourcesContent":["/* All fonts are self-hosted via public/fonts/gfonts.css (linked from\n   index.html). CDN imports duplicated them and pinned Inter to weight 400,\n   which forced synthetic bold everywhere. */\n\n/* Thin (wght 300) Material 'close' glyph for dialog dismiss buttons, per the\n   Figma dialog spec. Inlined as a 1KB data URI so it ships inside the bundle:\n   a cached/stale gfonts.css cannot silently drop the face and fall back to\n   the thick wght-400 X. */\n@font-face {\n  font-family: 'Material Symbols Outlined Thin';\n  font-style: normal;\n  font-weight: 300;\n  src: url(data:font/woff2;base64,d09GMgABAAAAAAQ0AA0AAAAAB7QAAAPhAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHGQGYD9TVEFUbABsEQgKhByDVwsSAAE2AiQDEgQgBYRSByAbeAbIBB7+v7O6rypwD1FDtZUGlTNBj+Ws9BesZ/y90NfW/1yT742oLjYb2BQv+i8inkeVcWrorBJ0E5vogGwG4a2boB9cXYIATIwmFCk9M68Mm7N5rhsbGgT+r5Ax2+noxBAyekCDXgFDDMAyIE0iW4sWHXraK5AxHdkrJqPF0NGahCwkesTRHg0OshcW2vGivP9Oo6gnQTOW2gUokb2yN6AwiQAYFgF93MxwpMzsvLwmN9pLUtKFQHi65ywWEtKCzq65QkZmMgp9FivKSAidmDxmtoQkzAyIKd4hTHOgB+FpiqM4kMmAXEqTk6rg60UPbhcJhVbaceJhzuu899+p6gI75beqb9ST6gn1kHpA3Tvs3qDw7XQy8gVCVQk5Zhr0ziAW5LTpt4YKjUl7LbQpSvBqZBkfaRlv0dls0836EF1LbY1DW1VlrRG1lsrEyoqk8sqEsvL4iubNgUBArAoGg+Ytfr+/3HQ8EAiYNvt8Plb6zVuCweBws8/n85m1PbERgo1fa9aaNSE0bw4IsarLGljpq9gSFGKVKMEw5UZz71yxKhAIjL0/BdPSZGr0wyv9fn+E389K35fe6d6XS2613mrf8dXXt1q/2NV2q7XmRnMTqv/Qy5cvXzrvzr+2suMTF1dlr6upzV67uPL4xLK4Vb1nh5ZVWtNrvrXH1I5ssoxLXjqqJSO+M31HYP36kR2WZiU7LqFGm15evTB0Q29cVwbnfvSTM8f5x1fZeB41ub/M5ZXt4p9n7/e8/yFevPDn+bs97/6R8/lrnyzb0XPHk+Vr1z9etrPnzidLeWe7+1/5HF2NLuli3OWzVyPCxnSGrleW9WoNLurtnJCbm1R0u+GHPy64K3S1upS9kZfP7JgSPSh//Mxhs/tkfDn886rOul9qAHiJAKS//l/644/3GkPi/zZIshfgg+P6S4APjsffg3pO9speONDdOuYmsi+BbcnVtBnpQvbyJQFUJ+PCQwbRZJIG0crI29yR9tu4DpvGSIeaRHqMChKFDpWw8R8qU8TFUU09qmUQ2zU6YimTxQ/ClEeRCJlIBSoxgImojIVhQR2m10UBNWHBAOZX8Hoo4XQzlwI8zMZFM07ycNBJF3OppB1Q2CbgoLXep1BKrVpMO3Zm00wbt0smDpw4yaeZubQzG0e78lIW4aIFj5o+h0LmMZdb7sBNO21MIQUVPaQ5/Lce3CiEMpUYIoii9eOwU0gh9iERQUpI+ObhpCfPHmOSwk9WeEMlOw0P3SzqyeboRe8ynVAiUbDjwUMnTtp7bMojjakoKKQcVEShRIU5qUA7c5YB84nA1N9ji9H5sQE=) format('woff2');\n}\n\nhtml {\n    scroll-behavior: smooth;\n}\n\nbody {\n    margin: 0;\n    color: var(--black-85);\n    background: var(--panel-bg-level-0);\n    font-family: 'Inter', sans-serif;\n    box-sizing: border-box;\n    letter-spacing: 0.02em;\n    /* Figma renders text grayscale-antialiased; macOS subpixel AA makes the\n       same weights read heavier/brighter on dark backgrounds. */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\ndiv {\n    padding: 0;\n    border: 0;\n    margin: 0;\n\n    text-overflow: clip;\n    box-sizing: border-box;\n    background-clip: border-box;\n}\n\n/* SearchBox is contenteditable rather than an input. Keep its text/caret on\n   one vertical axis everywhere; individual surfaces only own width, colors,\n   and the horizontal room reserved for their search icon. */\n.searchbox-control[data-searchbox] {\n    padding-top: 0;\n    padding-bottom: 0;\n    /* A line box is needed even when the editable control is empty; flex\n       centers placeholder text but leaves an empty contenteditable caret at\n       the top. 30px is the 32px control less its 1px borders. */\n    line-height: 30px;\n}\n\n.search:has(> .searchbox-control.searchbox[data-searchbox]) {\n    position: relative;\n}\n\n.search:has(> .searchbox-control.searchbox[data-searchbox]) > .icon {\n    top: 50%;\n    transform: translateY(calc(-50% + 2px));\n}\n\n:focus-visible {\n    outline: none;\n}\n\n::-webkit-scrollbar { \n    width: 7px;\n    height: 7px;\n}\n::-webkit-scrollbar-thumb { \n    background: var(--black-25);\n    border-radius: 5px;\n}\n::-webkit-scrollbar-thumb:hover {\n    filter: brightness(1.2);\n}\n::-webkit-scrollbar-corner {\n    background-color: #00000000;\n}\n\n:root {\n    --panel-bg-level-0: #101820;\n    --black_10:#040608;\n    --black-00: var(--panel-bg-level-0);\n    --black-02: #171F27;\n    --black-03:#182027;\n    --black-05:#1c242b;\n    --black-07:#22282f;\n    --black-10:#282f36;\n    --black-15:#343b41;\n    --black-20:#40464d;\n    --black-25:#4c5258;\n    --black-30:#575d62;\n    --black-35:#64696e;\n    --black-45:#7c8084;\n    --black-50:#878b8f;\n    --black-65:#abaeb1;\n    --black-75:#c3c5c7;\n    --black-80:#cdcdce;\n    --black-85:#dbdcde;\n    --black-90:#e7e8e9;\n    --node-bg:#343b43;\n    --blue-1:#2c3a74;\n    --blue-2:#5a6ccd;\n    --hover-fg: var(--black-65);\n    --hover-bg: var(--black-15);\n    /* Hover highlight for anything clickable that paints its own surface. A\n       layer over background-color, not box-shadow or filter: those would erase\n       the elevation shadows in chains and group descendants into one rendering\n       context. Read-only elements get no hover at all. */\n    --hover-veil: rgba(255,255,255,0.06);\n    /* Half strength, for surfaces large enough that the full veil reads as a\n       selection instead of a hover. Node cards on the devices screen. */\n    --hover-veil-soft: rgba(255,255,255,0.03);\n    /* Same job for a bare glyph or label, which has no surface to layer over.\n       Relative, because a fixed target colour would dim anything already near\n       the top of the scale. Only for leaf elements: filter groups descendants. */\n    --hover-lift: 1.15;\n    --red-1: #58292d;\n    --red-2: #B72828;\n    --red-3: #ec736a;\n    --green-1: #49c97c;\n    /* Warm sand, same ink as the slot pocket edge in chain.css. Marks a\n       non-production build. */\n    --amber-1: #f4d09f;\n    --dark-red: #28161c;\n\n    /* Dialog/button tokens from the Figma dialog spec (ProPatch v1.0 \"GUI\n       Refactor\"); names match Wolffhound's index.css so the two apps share\n       one vocabulary. */\n    --ui-modal-bg: #293037;\n    --ui-modal-radius: 4px;\n    --ui-modal-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);\n    --ui-modal-header-height: 34px;\n    --ui-modal-header-bg: #485cc7;\n    /* Gosta (round 3): everything reddish becomes the pastel/pinkish red,\n       CHAIN INVALID included. The deep red in node 3495:40284 is an outdated\n       raster. Header and button share the color on red dialogs. */\n    --ui-modal-header-bg-danger: var(--red-3);\n    --ui-modal-header-text-danger: var(--black-20);\n    /* Dialog primary is deliberately brighter than the #485cc7 header: \"the\n       button and the header are the same for the red, different for the blue\"\n       (design review round 3 pt2). */\n    --ui-button-bg-primary: #6e80e0;\n    /* Round 4 (Gosta): primary button text matches the modal background. */\n    --ui-button-text-primary: var(--ui-modal-bg);\n    --ui-button-border-secondary: var(--black-65);\n    --ui-button-text-secondary: var(--black-65);\n}\n\n[data-sonner-toast] {\n    transition: height 200ms ease, box-shadow 200ms ease, opacity 200ms ease;\n}\n.toast {\n    font-size: 13px;\n    text-align: left;\n    display: flex;\n    align-items: center;\n    animation: toast-in 150ms ease;\n}\n@keyframes toast-in {\n    from { opacity: 0.5; }\n    to   { opacity: 1; }\n}\n.toast-icon {\n    font-size: 16px;\n    opacity: 0.6;\n}\n.toast-body {\n    margin-left: 8px;\n}\n.toast-label {\n    font-weight: 600;\n}\n.toast-verb {\n    opacity: 0.6;\n}\n.toast-note {\n    opacity: 0.4;\n    font-size: 12px;\n}\n.toast-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 11px;\n}\n.toast-header-label {\n    font-weight: 600;\n    opacity: 0.5;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n.toast-header-note {\n    opacity: 0.4;\n}\n.toast-divider {\n    border-bottom: 1px solid rgba(255,255,255,0.1);\n    padding-bottom: 6px;\n    margin-bottom: 6px;\n}\n.toast-row {\n    display: flex;\n    align-items: center;\n}\n\n.symbols {\n    font-family: 'Material Symbols Outlined';\n    user-select: none;\n}\n\n.mui-icons {\n    font-family: 'Material Icons';\n}\n\n.acticon { \n    border-radius: 4px;\n    font-size: 24px;\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n    user-select: none; \n}\n\n.acticon:hover {\n    filter: brightness(1.4);\n}\n\n.tridot {\n    font-size: 24px;\n    width: 24px;\n    line-height: 0.95;\n    cursor: pointer;\n    user-select: none;\n    font-family: 'Material Symbols Outlined';\n    /* the more_vert ink sits ~1.5px high in its line box: nudge the glyph\n       itself, wherever a box centers it (measured on the 40px browser rows:\n       11px over / 13.5px under before the shift) */\n    position: relative;\n    top: 1.5px;\n}\n\n.tridot:hover {\n    filter: brightness(1.3);\n}\n\n#propatch-model {\n    position: absolute;\n    top: 20px;\n    left: 21px;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: normal;\n    letter-spacing: 0.02em;\n    color: white;\n    cursor: pointer;\n    user-select: none;\n}\n\n#propatch-model:hover {\n    color: var(--black-90);\n}\n\n/* The build stamp rides on the model number's baseline: the 12px gap between\n   the title and #browser-main has no room for a line of its own. */\n#propatch-model .model-line {\n    display: flex;\n    align-items: baseline;\n    gap: 7px;\n}\n\n/* 10px keeps the longest case (PP128R + a two-digit minor) clear of the\n   session selector, which starts at 192px */\n#build-stamp {\n    font-size: 10px;\n    font-weight: 400;\n    letter-spacing: 0;\n    white-space: nowrap;\n}\n\n/* .version inherits the title's colour, hover included */\n#build-stamp .version,\n#build-stamp .build,\n#build-stamp .channel {\n    display: inline;\n}\n\n#build-stamp .build {\n    color: var(--black-35);\n}\n\n#build-stamp .channel {\n    color: var(--amber-1);\n    text-transform: uppercase;\n}\n\n#session {\n    /* Figma \"text input\" session selector is 188x32 (node 3463:60747) */\n    width: 188px;\n    height: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n#friendly {\n    width: 180px;\n    height: 100%;\n    margin-right: 16px;\n\n    font-size: 15px;\n    border-radius: 4px;\n\n    background-color: var(--black-10);\n\n    display: flex;\n    text-align: left;\n    align-items: center;\n}\n\n#friendly.undefined {\n    background-color: var(--red-3);\n    color: var(--black-20);\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n#friendly.undefined.connected {\n    background-color: var(--green-1);\n}\n\n#friendly .name {\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 75%, transparent 100%);\n}\n\n#friendly.defined .name {\n    padding-left: 10px;\n}\n\n#friendly.defined .name::before {\n    font-family: 'Material Icons';\n    font-size: 13px;\n    color: var(--red-3);\n    content: 'circle';\n    padding-right: 6px;\n}\n\n#friendly.defined.connected .name::before {\n    color: var(--green-1);\n}\n\n#friendly .name.edit {\n    background-color: var(--black_10);\n    color: var(--black-90);\n    border: var(--black-90) solid 1px;\n    border-radius: 4px;\n    text-overflow: clip;\n}\n\n#chain-new,\n#device-new {\n    /* Gosta (round 6): one 20px inset for all tabs/buttons and chains */\n    margin-left: 20px;\n}\n\n#device-new {\n    background-color: green;\n}\n\n#chain-new .symbol,\n#device-new .symbol {\n    /* Figma plus glyph sits in a 24px slot with 8px padding (node 3463:60746) */\n    font-size: 20px;\n}\n\n.symbol {\n    display: inline;\n    font-family: 'Material Symbols Outlined';\n    /* Figma header icons use the regular Material Symbols grade (node\n       3463:60746); 800 was synthesizing a faux bold. */\n    font-weight: 400;\n}\n\n#top-icons {\n    /* Figma header: session selector at x=192, controls at y=18, settings\n       gear box 25px off the right edge (node 3463:60740, frame 1499 wide,\n       gear box 1446+28). WH's titlebar logo shares the same 25px inset. */\n    margin-left: 192px;\n    margin-right: 25px;\n    margin-top: 18px;\n    height: 32px;\n    max-height: 32px;\n    display: flex;\n    justify-content:space-between;\n    align-items: center;\n}\n\n.top.cta {\n    /* Figma header buttons: 12px sides, 4px vertical, 4px icon-label gap\n       (node 3463:60742). The gap replaces the old &nbsp; spacing. */\n    padding: 4px 12px;\n    gap: 4px;\n    height: 100%;\n}\n\n#top-left, #top-right {\n    height: 32px;\n    max-height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n#top-right {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    justify-content:space-between;\n}\n\n#midi-over {\n    display: none;\n    position: absolute;\n    height: 100vh;\n    width: 100vw;\n    background-color: rgba(0,0,0,0.5);\n    z-index: 1;\n    backdrop-filter: blur(0.8px);\n}\n\n/* Figma \"btn MIDI/shortcut\" variant (node 3463:60742): outline, no fill */\n#shortcuts {\n    margin-right: 20px;\n    background-color: transparent;\n    outline: 1px solid var(--blue-1);\n    outline-offset: -1px;\n}\n\n#shortcuts .symbol {\n    /* the cmd glyph inks 0.75 of its em box; the design's icon ink is 17.5px\n       (node 2351:40963, 17.5px mask in a 24px slot) — 23px em lands there */\n    font-size: 23px;\n}\n\n/* Figma gives every header-button icon a 20px slot and lets the ink spill\n   over it (buttons hug to 126/76/116); without the clamp the bigger glyphs\n   widen the buttons */\n#shortcuts .symbol,\n#mute-all .symbol {\n    width: 20px;\n    display: inline-flex;\n    justify-content: center;\n    overflow: visible;\n}\n\n#midi .midi-port-icon {\n    margin: 0 -2px;\n}\n\n#midi {\n    margin-right: 20px;\n    position: relative;\n    pointer-events: none;\n    filter: brightness(0.7);\n}\n\n#midi.enabled {\n    filter: brightness(1);\n    pointer-events: all;\n}\n\n/* Offline MIDI is an active route to Configuration, while a connected MIDI\n   button remains gated by the current chain/MIDI-Learn eligibility. */\n#midi.midi-bad {\n    pointer-events: all;\n}\n\n#midi.enabled.selected {\n    filter: brightness(1.1);\n    outline: 2px solid var(--black-80);\n    z-index: 2;\n}\n\n#chain-new:hover,\n#device-new:hover,\n.devcfg .node-new:hover,\n#shortcuts:hover,\n#midi:hover,\n#mute-all:hover {\n    filter: brightness(1.3);\n}\n\n.midi-ports .port {\n    color: var(--black-65);\n}\n\n.midi-ports .port.selected {\n    color: var(--black-80);\n}\n\n.midi-ports .port.bad {\n    font-style: italic;\n    color: var(--black-45);\n}\n\n.midi-learn {\n    z-index: 2;\n    pointer-events: all;\n}\n\n.midi-learn.learning {\n    animation: pulse-fg 0.3s ease-in-out infinite;\n}\n\n@keyframes pulse-fg {\n    0%, 100% {\n        outline-width: 0.1px;\n        outline-color: rgba(147, 55, 255, 0);\n        filter: brightness(0.8);\n    }\n    50% {\n        outline-width: 3px;\n        outline-color: rgba(147, 55, 255, 0.5);\n        filter: brightness(1);\n    }\n}\n\n.midi-learn::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 120cqw;\n    height: 120cqh;\n    background: rgb(147, 55, 255);\n    transform: translate(-50%, -50%);\n    animation: pulse-bg 1.5s ease-in-out infinite;\n    z-index: 2;\n}\n\n.midi-learn.learning::after {\n    animation: pulse-bg 0.3s ease-in-out infinite;\n}\n\n@keyframes pulse-bg {\n    0%, 100% {\n        opacity: 0;\n    }\n    50% {\n        opacity: 0.65;\n    }\n}\n\n#mute-all .symbol {\n    /* the power glyph's ink is 20/24 of its em box; the design's icon ink is\n       17.5px in the 32px button (node 2351:40765) — 21px em lands exactly there */\n    font-size: 21px;\n}\n\n#mute-all {\n    position: relative;\n    height: 32px;\n    /* Figma fixes this button at 116px, 19px before the gear (nodes\n       3463:60745 / 3463:60752). */\n    width: 116px;\n    background-color: var(--red-1);\n    margin-right: 19px;\n}\n\n#system-menu {\n    height: 28px;\n    width: 28px;\n    box-shadow: none;\n\n    border-radius: 4px;\n\n    background: transparent;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    line-height: 1.3;\n\n    cursor: pointer;\n    user-select: none;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n/* Figma gear fill is #CDCDCE (node 3463:60752); the glyph is an SVG child */\n#system-menu .tridot {\n    color: var(--black-80);\n    display: flex;\n    align-items: center;\n    /* the SVG is its own ink — the text-glyph nudge on .tridot must not move it */\n    top: 0;\n}\n\n#system-menu.update .tridot {\n    animation: system-menu 600s ease-in-out infinite;\n}\n\n@keyframes system-menu {\n    0%,0.25%,0.5% { transform: scale(1); }\n    0.125%,0.375% { transform: scale(1.4); }\n}\n\n#system-menu:hover {\n    background: rgba(255, 255, 255, 0.1);\n}\n\n/* Match the neighboring header buttons by lightening the gear ink on hover. */\n#system-menu:hover .tridot {\n    filter: brightness(1.3);\n}\n\n#system-menu.update {\n    width: 100px;\n    justify-content: right;\n    background-color: var(--blue-1);\n}\n\n#system-menu.update .text {\n    font-size: 17px;\n}\n\n/* soft, sweeping highlight */\n.shimmer {\n    position: relative;\n    overflow: hidden;\n    background-color: #1F2937;\n    color: #D1D5DB;\n}\n\n.shimmer::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -120%; /* Start off-screen */\n    width: 50%;\n    height: 100%;\n    background: linear-gradient(\n        90deg,\n        transparent,\n        rgba(255, 255, 255, 0.14), /* faint white highlight */\n        transparent\n    );\n    transform: skewX(-25deg); /* Skews the light source for a more dynamic look */\n    animation: shimmer 600s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n    0%,1%,2%,100% { left: -120%; }\n    0.5%,1.5% { left: 120%; }\n}\n\n#space {\n    position: fixed;\n    top: 70px;\n    left: 380px;\n    right: 0;\n    height: calc(100vh - 72px - 5px);\n    overflow: hidden;\n}\n\n/* Every workspace uses the external right rail: an 8px thumb remains\n   centered in 20px between the content frame and the window edge. */\n#space > *::-webkit-scrollbar {\n    width: 20px;\n}\n\n#space > *::-webkit-scrollbar-thumb {\n    border: 6px solid transparent;\n    background-clip: padding-box;\n    /* The painted radius is border-radius minus the border, so 10px keeps the\n       visible 8px thumb a full pill (Gosta, Aug 4) */\n    border-radius: 10px;\n}\n\n#space.midi-learning {\n    z-index: 1;\n}\n\n/* The screen is pointer-disabled during MIDI Learn, but the native scroll\n   container still needs to win wheel hit-testing. Keep its cards inert; the\n   existing .midi-learn rule selectively re-enables eligible controls. */\n#space.midi-learning .chain-space {\n    pointer-events: auto;\n}\n\n#space.midi-learning .chain-space > * {\n    pointer-events: none;\n}\n\n/* Disconnected banner occupies y72..147; chains resume at 163 (Figma NODES VIEW) */\n#screen.disconnected #space {\n    top: 163px;\n    height: calc(100vh - 165px - 5px);\n    transition: top 0.2s ease, height 0.2s ease;\n}\n\n/* Collapsed banner is head-only (ends at y112) — chains take the freed\n   space, keeping the same 16px gap as the expanded state */\n#screen.disconnected:has(.app-banner.collapsed) #space {\n    top: 128px;\n    height: calc(100vh - 130px - 5px);\n}\n\n.menu {\n    position: absolute;\n    z-index: 100;\n    border-radius: 2px;\n    background: var(--black-07);\n    padding: 6px 6px 6px 6px;\n    width: 160px;\n}\n  \n.menu .item  {\n    position: relative;\n    height: 32px;\n    padding-left: 10px;\n    color: var(--black-80);\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 160px;\n}\n\n.menu .item.submenu {\n    height: 38px;\n    padding-top: 4px;\n}\n  \n.menu .item.divider {\n    border-top: 1px solid var(--black-30);\n}\n\n.menu .item:hover {\n    color: var(--black-90);\n    background: var(--hover-bg);\n}\n\n.menu .item.submenu::after {\n    content: '>';\n    position: absolute;\n    right: 10px;\n    font-size: 16px;\n    color: var(--black-90);\n}\n\n.menu .item .submenu  {\n    display: none;\n    position: absolute;\n    z-index: 100;\n    top: 0px;\n    left: -174px;\n    border-radius: 4px;\n    background: var(--black-07);\n    padding: 3px 8px 6px 8px;\n}\n\n.menu .item .submenu .item .submenu  {\n    display: none;\n    position: absolute;\n    z-index: 100;\n    top: 0px;\n    left: -100px;\n    border-radius: 4px;\n    background: var(--black-07);\n    padding: 3px 8px 6px 8px;\n}\n\n.menu .item:hover .submenu  {\n    display: block;\n}\n\n.menu .item .submenu .item:hover .submenu   {\n    display: block;\n}\n\n.menu .submenu .item {\n    color: var(--black-65);\n}\n\n.menu .submenu .item:hover {\n    color: var(--black-90);\n}\n\n.menu .item .choice  {\n    padding-right: 8px;\n}\n\n.menu .item .owner {\n    color: var(--black-45);\n}\n\n.menu .item.hilite .choice {\n    color: var(--black-90);\n}\n\n.hidden { display: none; }\n\n#ingest-errors {\n    position: fixed;\n    z-index: 999;\n    width: 90vw;\n    height: 50vh;\n    top: 25vh;\n    height: 50vh;\n    left: 5vw;\n    border-radius: 5px;\n    background: white;\n    color: black;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  }\n  \n  #ingest-errors pre {\n    padding-left: 10px;\n    height: 40vh;\n    font-size: 17px;\n    color: black;\n    overflow: scroll;\n  }\n  \n  #ingest-errors button {\n    display: flex;\n    color: black;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    width: 80px;\n  }\n\n#screen {\n    height: 100vh;\n    width: 100vw;\n    min-width: 1036px;\n    background: var(--panel-bg-level-0);\n    position: relative;\n    overflow: hidden;\n}\n\n#screen.disconnected {\n    background: var(--panel-bg-level-0);\n}\n  \n.midi-channel.selected .reserved {\n    padding-left: 10px;\n    opacity: 60%;\n    width: 100%;\n}\n\n.note.selected .reserved {\n    padding-left: 10px;\n    color: var(--black-80);\n    width: 100%;\n}\n\n.browser-device {\n    position: relative;\n    width: 320px;\n    height: 40px;\n    display: flex;\n    background-color: var(--black-10);\n    align-items: center;\n    color: var(--black-80);\n    border: 1px solid #00000000;\n}\n\n.browser-device:hover {\n    color: var(--black-90);\n    border-color: var(--black-35);\n}\n\n.browser-device.selected {\n    border-color: var(--black-45);\n}\n\n.browser-device .name {\n    position: absolute;\n    left: 10px;\n    width: 100%;\n\n    font-size: 13px;\n    font-weight: bold;\n    letter-spacing: 0.26px;\n    color: var(--black-65);\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 75%, transparent 100%);\n}\n\n.browser-device.selected .name {\n    color: var(--black-90);\n    font-weight: bold;\n}\n\n.browser-device .popup {\n    position: absolute;\n    top: 8px;\n    right: 1%;\n\n    font-size: 24px;\n}\n\n.browser-module {\n    border-radius: 2px;\n    position: relative;\n    height: 40px;\n    width: 320px;\n\n    display: flex;\n    background-color: var(--node-bg);\n\n    align-items: center;\n}\n\n/* Node browser rows are drag sources, so they react to the pointer. The drag\n   wrapper is transparent; the row background lives on .browser-module. Matches\n   .browser-device, which already had a hover. */\n.browser .isolatable:hover .browser-module {\n    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));\n}\n\n.browser-module.invalid {\n    background: var(--red-1);\n}\n\n.browser-module .popup {\n    font-size: 24px;\n    position: absolute;\n    top: 8px;\n    right: 3px;\n}\n\n.popup-menu .menu-list .menu-item.octave {\n    display: block; \n    text-align: right; \n}\n\n.browser-module.submodule {\n    /* Figma nested/sub rows are a step darker than --black-10 (raw hex in the\n       design, node 3463:60739) */\n    background-color: #242a30;\n}\n\n.browser-module .expander {\n    position: absolute;\n    right: 83px;\n    width: 18px;\n\n    color: var(--black-65);\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n    user-select: none; \n}\n\n.browser-module.invalid .expander {\n    color: var(--black-45);\n}\n\n.browser-module .device  {\n    position: relative;\n    left: 12px;\n    top: -8px;\n    /* Figma text block is fixed 265px (node 3463:60739) */\n    width: 265px;\n\n    font-size: 13px;\n    font-weight: bold;\n    letter-spacing: 0.26px;\n    color: var(--black-65);\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 80%, transparent 100%);\n}\n\n.browser-module.invalid .device  {\n    color: var(--black-45);\n    font-style: italic;\n}\n\n.browser-module.stereo .device {\n    width: 210px;\n}\n\n.browser-module.m2s .device  {\n    width: 230px;\n}\n\n.browser-module .name {\n    position: absolute;\n    bottom: 3px;\n    left: 12px;\n    width: 260px;\n\n    font-size: 13px;\n    color: var(--black-65);\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 80%, transparent 100%);\n}\n\n.browser-module.invalid .name {\n    color: var(--black-45);\n    font-style: italic;\n}\n\n.browser-module.stereo .name {\n    width: 210px;\n}\n\n.browser-module.m2s .name {\n    width: 240px;\n}\n\n.browser-module .channels {\n    position: absolute;\n    right: 24px;\n    height: 100%;\n\n    font-size: 11px;\n\n    white-space: nowrap;\n    text-overflow: clip;\n\n    text-align: center;\n    display: flex;\n    justify-content: right;\n    align-items: center;\n}\n\n.browser-module .channels .channel {\n    height: 26px;\n    width: 26px;\n\n    font-weight: normal;\n\n    border-radius: 26px;\n    color: var(--black-80);\n    background-color: var(--black-25);\n\n    box-shadow: 0 0 1px var(--black-05);\n\n    font-size: 13px;\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.browser-module.invalid .channels .channel {\n    color: var(--black-45);\n}\n\n.browser-module .channels .channel.used {\n    color: var(--black-05);\n    font-weight: 500;\n}\n\n.browser-module .channels .channel.m2s {\n    position: relative;\n    width: 42px;\n    font-size: 12.5px;\n}\n\n.browser-module .channels .channel.stereo.L {\n    margin-right: 3px;\n}\n\n/* DOUBLE-CLICK an L/R chip to add just that channel */\n.browser-module .channels .channel.choosable {\n    cursor: pointer;\n}\n\n.browser-module .inuse {\n    position: absolute;\n    left: 306px;\n    width: 51px;\n    height: 24px;\n    font-size: 0px;\n\n    display: flex;\n\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    visibility: hidden;\n}\n\n.browser-module.used .inuse {\n    font-size: 13px;\n    font-weight: bold;\n\n    visibility:visible;\n}\n\n.browser-module .popup {\n    font-size: 22px;\n    color: var(--black-65);\n}\n\n#browser-main {\n    width: 360px;\n    align-content: start;\n    top: 70px;\n    position: absolute;\n    left:20px;\n    background-color: var(--black-05);\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n    height: 42px;\n    overflow-x: visible;\n}\n\n#browser-main .types {\n    padding-top: 12px;\n    /* tabs live in the panel's content frame: the first icon starts on the\n       content axis, the last tab ends flush with the search box's right edge */\n    padding-left: 20px;\n    padding-right: 20px;\n\n    color: var(--black-45);\n\n    display:flex;\n    text-align: center;\n    justify-content: space-between;\n    align-items: center;\n}\n\n#browser-main .types .choice .svgicon {\n    display:flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    padding-right: 4px;\n}\n\n#browser-main .types .choice {\n    font-size: 16px;\n    font-weight: 500;\n\n    cursor: pointer;\n    user-select: none;\n\n    display:flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n#browser-main .types .choice .symbols {\n    font-size: 20px;\n    /* the icon font only ships wght 400; a heavier label weight would\n       synthesize a thicker glyph */\n    font-weight: 400;\n    padding-right: 3px;\n    vertical-align: middle;\n}\n\n/* the flowchart glyph carries ~1.7px of left bearing inside its em box\n   (canvas actualBoundingBoxLeft); pull the first tab back so the visible\n   ink, not the box, starts on the content axis */\n#browser-main .types .choice:first-child .symbols {\n    margin-left: -2px;\n}\n\n#browser-main .types .choice:hover {\n    color: var(--black-80);\n}\n\n#browser-main .types .choice.selected {\n    color: var(--black-85);\n}\n\n#browser-main .types .choice .svgicon .fill {\n    fill: var(--black-45);\n}\n\n#browser-main .types .choice:hover .svgicon .fill {\n    fill: var(--black-80);\n}\n\n#browser-main .types .choice.selected .svgicon .fill  {\n    fill: var(--black-85);\n}\n\n#browser {\n    width: 360px;\n    align-content: start;\n    top: 112px;\n    position: absolute;\n    left:20px;\n    background-color: var(--black-05);\n    /* #browser-main's tab strip sits on top of this surface: rounding the\n       top corners here notched the panel's edge at the seam (Gosta's\n       \"round corner bug\") — only the strip rounds the top, only this\n       surface rounds the bottom */\n    border-radius: 0 0 4px 4px;\n    height: calc(100vh - 116px - 5px);\n    overflow-x: visible;\n}\n\n.browser {\n    position: relative;\n    display:flex;\n    flex-direction: column;\n    background-color: var(--black-30);\n    align-items: center;\n    overflow: visible;\n}\n\n.browser .search-hr {\n    width: 320px;\n    height: 1px;\n    margin-bottom: 14px;\n}\n\n.browser .tag-hr {\n    width: 320px;\n    height: 1px;\n    background-color: var(--black-25);\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\n/* One content axis for the panel (Gosta, round 6): search, pills, type tabs\n   and rows all share the rows' frame — 20px from the panel's left edge, 328px\n   wide — instead of each centering to its own width; the scrollbar keeps its\n   own gutter to the right of that frame */\n.browser .search,\n.browser .filters,\n.browser .types,\n.browser .search-hr,\n.browser .tag-hr {\n    align-self: flex-start;\n    margin-left: 20px;\n}\n\n.browser .search {\n    margin-top: 4px;\n}\n\n.browser .search .icon {\n    position: absolute;\n    left: 10px;\n    font-size: 22px;\n    color: var(--black-45);\n    user-select: none;\n}\n\n.browser .searchbox {\n    font-size: 15px;\n\n    width: 320px;\n    height: 32px;\n    /** if missing, caret appears in upper left of searchbox when empty (and focused) */\n    padding: 0 5px;\n    padding-left: 38px;\n\n    color: var(--black-65);\n    background-color: var(--black-10);\n\n    border: solid var(--black-15) 1px;\n    border-radius: 4px;\n\n    /** prevents default outlining of active input text box */\n    outline: none;\n\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    text-align: left;\n    overflow: hidden;\n}\n\n.browser .searchbox.hidden {\n    display: none;\n}\n  \n.browser .searchbox.empty {\n    color: var(--black-35);\n    user-select: none;\n}\n\n.browser .searchbox.edit {\n    font-style: normal;\n    text-overflow: clip;\n    overflow: hidden;\n    color: var(--black-80);\n    background-color: var(--black-20);\n}\n\n.browser.module .types {\n    color: var(--black-45);\n\n    margin-top: 14px;\n    margin-bottom: 0px;\n\n    height: 100%;\n    max-height: 24px;\n\n    display: flex;\n    align-items: center;\n    gap: 18px;\n}\n\n.browser .types .choice {\n    font-size: 15px;\n    letter-spacing: 0;\n\n    cursor: pointer;\n    user-select: none;\n\n    display:flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.browser .types .choice:hover {\n    color: var(--black-80);\n}\n\n.browser .types .choice.selected {\n    color: var(--black-85);\n}\n\n.browser .types .choice .svgicon {\n    display:flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.browser .types .choice .svgicon .fill {\n    fill: var(--black-45);\n}\n\n.browser .types .choice:hover .svgicon .fill {\n    fill: var(--black-80);\n}\n\n.browser .types .choice.selected .svgicon .fill  {\n    fill: var(--black-85);\n}\n\n.browser .filters {\n    width: 320px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    margin-top: 15px;\n    margin-bottom: 4px;\n}\n\n.browser .header .type {\n    position: absolute;\n    left: 5px;\n\n    font-size: 18px;\n    font-weight: bold;\n    color: var(--black-85);\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    user-select: none; \n}\n\n.browser .header .sort,\n.browser .header .active {\n    height: 22px;\n    border-radius: 4px;\n\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0.3px;\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n    user-select: none;\n}\n\n/* Figma sort row: plain 12px label + arrow, no pill (node 16:17337) */\n.browser .header .sort {\n    color: var(--black-65);\n    background-color: transparent;\n    gap: 2px;\n}\n\n.browser .header .sort .symbols {\n    font-size: 16px;\n}\n\n/* The filter is always on, only its label changes, so the pill stays light in\n   all three states the way prod has it (Gosta, July 20) */\n.browser .header .active {\n    width: 75px;\n    padding-left: 12px;\n    padding-right: 10px;\n    color: var(--black-05);\n    background-color: var(--black-80);\n}\n\n.browser .header .sort:hover {\n    color: var(--black-80);\n}\n\n.browser .header .active:hover {\n    color: var(--black-05);\n    background-color: var(--black-65);\n}\n\n.browser .header {\n    width: 320px;\n    margin-bottom: 8px;\n\n    font-size: 22px;\n\n    display: flex;\n    text-align: center;\n    justify-content:space-between;\n    align-items: center;\n}\n\n.browser .header > .left {\n    display: flex;\n    text-align: center;\n    justify-content: left;\n    align-items: center\n}\n\n.browser .header > .right {\n    display: flex;\n    text-align: center;\n    justify-content: left;\n    align-items: center;\n}\n\n.chain.browser .header .fave {\n    margin-left: 10px;\n    height: 22px;\n    color: var(--black-35);\n}\n\n.chain.browser .header .fave.selected {\n    color: var(--black-80);\n}\n\n.chain.browser .header .fave:hover {\n    color: var(--black-65);\n}\n\n.chain.browser .header .normal {\n    font-size: 23px;\n    height: 22px;\n    margin-left: 13px;\n    color: var(--black-35);\n}\n\n.chain.browser .header .normal.selected {\n    color: var(--black-80);\n    font-weight: bold;\n}\n\n.chain.browser .header .normal:hover {\n    color: var(--black-65);\n}\n\n.browser .results {\n    position: relative;\n    flex-grow: 1;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    /* pinned to the content axis like .search/.filters above: without\n       align-self the panel centers the margin box and the left edge drifts\n       with the width (39 here, 43.5 in the chain browser) */\n    align-self: flex-start;\n    margin-left: 20px;\n    /* 320px content + 14px so the 8px scrollbar centers in the right 20px\n       gutter: 6px off the rows, 6px off the panel edge (Gosta, round 6) */\n    width: 334px;\n}\n\n.browser .results::-webkit-scrollbar {\n    width: 8px;\n}\n\n.browser .results .items {\n    width: 320px;\n}\n\n.browser .results .items .item {\n    /* Figma list rhythm: 40px row + 4px gap (node 3463:60739) */\n    min-height: 44px;\n    padding: 2px 0;\n}\n\n/* The scrollbar track starts at the results box: zero only the actual first\n   card's top padding so the thumb starts level with it. Node rows have an\n   extra wrapper, so a descendant :first-child would match every Node row and\n   collapse their intended 4px rhythm to 2px. */\n.browser .results .items > .item:first-child,\n.browser.module .results .items > :first-child > .item:first-child {\n    padding-top: 0;\n    min-height: 42px;\n}\n\n/* The device browser is a flush list (ProPatch 1.5 ref): rows touch,\n   the zebra alone separates them; nodes and chains keep the carded\n   4px rhythm — gaps mark rows as draggable objects, and node shades\n   carry meaning only inside chains (Jared, Figma round 6).\n   Content frame is 320px: 20px inset on BOTH panel edges (Gosta), the\n   scrollbar centers in the right 20px gutter */\n.browser.device .results .items .item {\n    min-height: 40px;\n    padding: 0;\n}\n\n.browser.device .results .items .item:nth-child(odd) .browser-device {\n    background-color: var(--black-15);\n}\n\n.browser .results .items .item .subitem  {\n    min-height: 42px;\n    display: none;\n}\n\n.browser .results .items .item .subitem.expanded {\n    display: block;\n}\n\n.browser .results .items .item .subitem.expanded.top {\n    margin-top: 2px;\n}\n\n.browser .results .items .empty {\n    height: 42px;\n    padding-right: 40px;\n\n    font-size: 14px;\n    font-style: italic;\n    color: var(--black-45);\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    user-select: none; \n}\n\n.browser.device > .cta.new {\n    left: 21px;\n}\n\n#controls {\n    display: flex;\n    gap: 14px;\n    top: 10px;\n    position: absolute;\n    left:506px;\n}\n\n/* App-chrome CTA per Figma \"btn cta primary\" (node 3463:60746): #2c3a74 fill,\n   light text. Dialog CTAs are recolored in widgets.css to the dialog spec. */\n.cta {\n    height: 32px;\n    padding-left: 16px;\n    padding-right: 16px;\n    border-radius:4px;\n    background-color: var(--blue-1);\n\n    box-shadow: none;\n\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    color: var(--black-90);\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n    user-select: none;\n\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.cta:hover {\n    color: var(--black-65);\n}\n\n.cta.secondary {\n    color: var(--ui-button-text-secondary);\n    outline: 1px solid var(--ui-button-border-secondary);\n    outline-offset: -1px;\n    background-color: transparent;\n}\n\n.cta.secondary:hover {\n    color: var(--black-80);\n    background-color: transparent;\n}\n\n/* Active but deliberately de-emphasized actions, such as “Don't save”. */\n.quiet {\n    opacity: 0.72;\n}\n\n.quiet:hover {\n    opacity: 1;\n}\n\n.modal.modtype .options {\n    display: flex;\n    gap: 22px;\n    justify-content: space-around;\n    padding-left: 22px;\n    padding-right: 22px;\n    padding-top: 20px;\n}\n\n.modal.modtype .options .option {\n    font-size: 48px;\n    height: 130px;\n    padding-left: 20px;\n    padding-right: 20px;\n    border-radius: 4px;\n    background-color: var(--black-15);\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n    user-select: none; \n}\n\n.popup {\n    user-select: none; \n    cursor: pointer;\n}\n\n/* The container is a pure positioning box — the rounded .menu-list inside\n   draws the border and shadow, so a square outline never peeks out. */\n.popup-menu {\n    visibility: hidden;\n    position: absolute;\n    transition: opacity 0.2s ease-in-out;\n    background-color: transparent;\n}\n\n.popup-menu > .menu-list {\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);\n}\n\n.popup-menu:hover {\n    display: block;\n}\n  \n.menu-list,\n.submenu-list {\n    border-radius: 4px;\n    font-size: 13px;\n    font-weight: 500;\n    list-style: none;\n    margin-top: 5px;\n    /* match the 5px side insets so the first item's top gap reads the same */\n    padding-top: 5px;\n    padding-bottom: 5px;\n    padding-left: 5px;\n    padding-right: 5px;\n    background-color: var(--black-00);\n    border: 1px solid var(--black-10);\n}\n\n.menu-item {\n    position: relative;\n    padding-left: 8px;\n    padding-right: 8px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    border-radius: 2px;\n\n    color: var(--black-80);\n    font-weight: 500;\n\n    cursor: pointer;\n    user-select: none;;\n    white-space: nowrap;\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* invisible hover zones extending from parent menu items */\n.menu-item.cascade::before {\n    content: '';\n    position: absolute;\n    top: -8px;\n    bottom: -8px;\n    left: -8px;\n    right: -15px; /* Extend further right toward submenu */\n    z-index: -1;\n    pointer-events: auto;\n  }\n\n  .submenu-list::before {\n    content: '';\n    position: absolute;\n    top: -8px;\n    bottom: -8px;\n    left: -15px; /* Connect back to parent menu */\n    right: -8px;\n    z-index: -1;\n    pointer-events: auto;\n  }\n\n  /* Increase hit area for cascade items */\n  .submenu-list {\n    padding-left: 5px;\n    padding-right: 4px;\n  }\n\n  /* Create invisible connection between submenu and parent */\n.menu-list::after,\n  .submenu-list::after {\n    content: '';\n    position: absolute;\n    top: -20px;\n    bottom: 0;\n    left: -10px; /* Invisible bridge from parent */\n    width: 20px;\n    pointer-events: auto;\n    z-index: 1;\n  }\n\n.menu-item.midi {\n    justify-content: left;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    color: var(--black-65);\n}\n\n.menu-item.midi .svgicon {\n    padding-top: 4px;\n}\n\n.menu-item.disabled {\n    color: var(--black-45);\n    font-weight: normal;\n}\n  \n.menu-item.shimmer {\n    background-color: var(--black-10);\n    border-radius: 2px;\n    color: #7db4f0;\n}\n\n.menu-item.active:hover {\n    background: var(--black-20);\n}\n\n.menu-item.cascade:hover {\n    background: var(--black-20);\n}\n\n.menu-item.div-top {\n    border-top: 1px solid var(--black-30);\n}\n\n.menu-item.div-bottom {\n    border-bottom: 1px solid var(--black-30);\n}\n  \n.menu-item:has(+ .div-top) {\n    padding-top: 10px;\n    padding-bottom: 11px;\n}\n\n.menu-item.cascade::after {\n    position: relative;\n    right: -4px;\n    font-family: 'Material Symbols Outlined';\n    font-size: 11px;\n    font-weight: bold;\n    content: \"arrow_forward_ios\";\n    margin-right: 0px;\n    color: var(--black-90);\n}\n\n.menu-item.cascade.empty::after {\n    color: var(--black-45);\n}\n\n.menu-item.cascade.disabled::after {\n    color: var(--black-45);\n}\n\n.menu-item.cascade.empty {\n    color: var(--black-45);\n}\n\n.submenu-list {\n    position: absolute;\n    visibility: hidden;\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);\n    margin-left: 5px;\n    z-index: 1000;\n}\n  \n.menu-item:hover > .submenu-list {\n    min-width: 40px;\n    visibility: visible;\n}\n\n.newmod .name.editbox {\n    font-size: 18px;\n    height: 28px\n}\n\n.modal .newmod .prompt {\n    color: var(--black-65);\n    font-size: 20px;\n}\n\n.modal .newmod .header {\n    font-size: 16px;\n    color: var(--black-65);\n}\n\n.modal .newmod .options {\n    padding: 10px;\n    background-color: var(--black-05);\n}\n\n.modal .newmod .option.selected {\n    background-color: var(--black-15);\n    color: var(--black-90);\n}\n\n.modal .newmod .cta.disabled {\n    background-color: var(--black-15);\n    color: var(--black-30);\n}\n\n.modal .newmod .option.disabled{\n    color: var(--black-35);\n}\n\n.modal .newmod .option:hover {\n    background-color: var(--black-25);\n}\n\n.midi-event {\n    z-index: 10;\n    border-radius: 32px;\n    visibility: hidden;\n    border: 5px solid var(--black-45);\n\n    font-weight: 500;\n    color: var(--black-80);\n\n    background-color: rgb(0 0 0 / 0.6);\n\n    position: absolute;\n    width: 250px;\n    height: 250px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    animation: fadeOut 1.2s ease-in;\n\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    pointer-events: none;\n}\n\n.midi-event .note {\n    font-size: 100px;\n    height: 100px;\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.midi-event .channel {\n    font-size: 38px;\n    height: 40px;\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.midi-event .state {\n    font-size: 42px;\n    height: 60px;\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.midi-event .ts {\n    font-size: 8px;\n    color: var(--black-45);\n}\n\n.midi-event::after {\n    position: absolute;\n    font-weight: normal;\n    opacity: 0.3;\n    font-family: 'Material Icons';\n    font-size: 250px;\n    content: 'music_note';\n    color: var(--black-65);\n}\n\n@keyframes fadeOut {\n    from { \n      visibility: visible; \n      opacity: 0.9;\n    }\n    to { \n      visibility: hidden; \n      opacity: 0; \n    }\n}  \n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
